import * as Sentry from '@sentry/vue'

export const SENTRY_DSN =
  'https://7b8d48511b6a5e074ce5c9614d966736@o4511223585243136.ingest.us.sentry.io/4511223588585472'

export function stripPii(event) {
  if (event.user) {
    delete event.user.email
    delete event.user.ip_address
    delete event.user.name
    delete event.user.username
  }
  if (event.request) {
    delete event.request.cookies
    if (event.request.headers) {
      delete event.request.headers['Cookie']
      delete event.request.headers['cookie']
    }
  }
  return event
}

export function initSentry(app) {
  if (!window.__SENTRY_ENABLED__) {
    return
  }

  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    initialScope: {
      tags: { app: 'toolkit-vue3-spa' },
    },
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1,
    beforeSend: stripPii,
  })

  if (window.__SENTRY_USER__) {
    Sentry.setUser(window.__SENTRY_USER__)
  }
}
